import Loadable from "react-loadable";
import LoadingComponent from "../../../../commons/loader";

export default [
  {
    path: `/reset-password/:token/:email`,
    exact: true,
    component: Loadable({
      loader: () => import("./index"),
      loading: LoadingComponent
    })
  }
];
